var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55332 6.25834C3.24666 4.87771 4.3103 3.7171 5.62535 2.90623C6.9404 2.09536 8.45504 1.66619 9.99999 1.66667C12.2458 1.66667 14.1325 2.49167 15.575 3.83751L13.1858 6.22751C12.3217 5.40167 11.2233 4.98084 9.99999 4.98084C7.82916 4.98084 5.99166 6.44751 5.33749 8.41667C5.17082 8.91667 5.07582 9.45001 5.07582 10C5.07582 10.55 5.17082 11.0833 5.33749 11.5833C5.99249 13.5533 7.82916 15.0192 9.99999 15.0192C11.1208 15.0192 12.075 14.7233 12.8217 14.2233C13.2545 13.9383 13.6251 13.5685 13.911 13.1363C14.1969 12.704 14.3922 12.2182 14.485 11.7083H9.99999V8.48501H17.8483C17.9467 9.03001 18 9.59834 18 10.1892C18 12.7275 17.0917 14.8642 15.515 16.3142C14.1367 17.5875 12.25 18.3333 9.99999 18.3333C8.90552 18.3338 7.82169 18.1185 6.81044 17.6999C5.7992 17.2813 4.88037 16.6674 4.10646 15.8935C3.33255 15.1196 2.71874 14.2008 2.3001 13.1896C1.88147 12.1783 1.66622 11.0945 1.66666 10C1.66666 8.65501 1.98832 7.38334 2.55332 6.25834Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/google-logo.dc9699ba06f2e04d56a562a667ed15f0.svg";
export { ForwardRef as ReactComponent };